import { Link } from "react-router-dom";
import { ShieldCheck, Users, Award, Leaf, ArrowRight } from "lucide-react";
import { IMAGES } from "../data/content";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="eyebrow">À propos</div>
            <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
              L'expertise<br/><span className="text-[#7DD923]">rénovation</span><br/>en Alsace
            </h1>
            <p className="text-white/70 mt-6 leading-relaxed">
              Optimeo Habitat accompagne les particuliers alsaciens dans leur transition énergétique. Notre mission : rendre la rénovation performante <strong className="text-white">simple, rentable et accessible</strong>.
            </p>
            <p className="text-white/70 mt-4 leading-relaxed">
              Basés en Alsace, nous combinons expertise technique (thermiciens, techniciens RGE), maîtrise des dispositifs d'aides (MaPrimeRénov', CEE) et exigence de qualité pour offrir un service haut de gamme.
            </p>
          </div>
          <div className="rounded-3xl overflow-hidden border border-white/5">
            <img src={IMAGES.technician} alt="Équipe Optimeo Habitat" className="w-full h-[520px] object-cover" />
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { icon: ShieldCheck, title: "Certifiés RGE", desc: "QualiPAC, Qualibat, Éco-Artisan" },
            { icon: Users, title: "Équipe locale", desc: "Techniciens salariés basés en Alsace" },
            { icon: Award, title: "10 ans de garantie", desc: "Décennale sur tous nos chantiers" },
            { icon: Leaf, title: "Engagement bas carbone", desc: "Matériaux et équipements durables" },
          ].map((v, i) => (
            <div key={i} className="bg-[#121212] border border-white/5 rounded-2xl p-6" data-testid={`about-value-${i}`}>
              <div className="w-10 h-10 rounded-full bg-[#7DD923]/10 border border-[#7DD923]/30 flex items-center justify-center mb-4">
                <v.icon className="w-5 h-5 text-[#7DD923]" />
              </div>
              <div className="text-white font-semibold">{v.title}</div>
              <div className="text-white/60 text-sm mt-1">{v.desc}</div>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center">
          <h2 className="font-display uppercase text-white text-4xl md:text-5xl leading-[0.95] tracking-tight">
            Envie de nous <span className="text-[#7DD923]">rencontrer</span> ?
          </h2>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <Link to="/devis" className="btn-primary">Étude gratuite <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/contact" className="btn-secondary">Nous contacter</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
